import httpClient from './httpClient';

const STATIC_LANDING_PAGE_END_POINT = '/backoffice/pages';

export const getStaticLandingPagesAPI = (params = {}) => httpClient.get(STATIC_LANDING_PAGE_END_POINT, {
	params: {
		...params,
		type: 'landing',
	},
});

export const createStaticLandingPageAPI = (data) => httpClient.post(STATIC_LANDING_PAGE_END_POINT, {
	...data,
	type: 'landing',
});

export const getStaticLandingPageAPI = (id) => httpClient.get(`${STATIC_LANDING_PAGE_END_POINT}/${id}`);

export const updateStaticLandingPageAPI = (id, data) => httpClient.put(`${STATIC_LANDING_PAGE_END_POINT}/${id}`, {
	...data,
	type: 'landing',
});

export const deleteStaticLandingPageAPI = (id) => httpClient.delete(`${STATIC_LANDING_PAGE_END_POINT}/${id}`);
